import React from 'react';

const DrawerToogle = (props) => {
    return (
        <div onClick={props.clicked}>Menu</div>
    );
}

export default DrawerToogle;